import { isEmpty } from 'ramda';

export const resolveLink = (link, url, params) => {
  if (link && !isEmpty(link)) {
    return { url: link };
  }
  return { url, params };
};
